import { render, staticRenderFns } from "./TournamentLocations.vue?vue&type=template&id=3a6c0a8c&"
import script from "./TournamentLocations.vue?vue&type=script&lang=js&"
export * from "./TournamentLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports